export const STAGE_FLOW = ["Pending", "Optimising", "At Machine", "In Rework Rack"];
export const MAINTENANCE = "In Maintenance Clearing";
export const LEFT_FACTORY = "Left Factory";
export const COLLECTED = "Collected";
export const COMPLETED = ["Completed - Finished Rack", "Completed - Maintenance", LEFT_FACTORY, COLLECTED];
export const ALL_STATUSES = [...STAGE_FLOW, ...COMPLETED, MAINTENANCE, "On Hold", "Cancelled"];
export const ACTIVE = [...STAGE_FLOW, "On Hold"];

export const STATUS_STYLES = {
  Pending: "bg-amber-100 text-amber-800 border-amber-300",
  Optimising: "bg-sky-100 text-sky-800 border-sky-300",
  "At Machine": "bg-cyan-100 text-cyan-800 border-cyan-300",
  "In Rework Rack": "bg-indigo-100 text-indigo-800 border-indigo-300",
  "Completed - Finished Rack": "bg-emerald-100 text-emerald-800 border-emerald-300",
  "Completed - Maintenance": "bg-lime-100 text-lime-800 border-lime-300",
  "In Maintenance Clearing": "bg-amber-100 text-amber-800 border-amber-300",
  "Left Factory": "bg-slate-200 text-slate-800 border-slate-400",
  "Collected": "bg-teal-100 text-teal-800 border-teal-300",
  "On Hold": "bg-orange-100 text-orange-800 border-orange-300",
  Cancelled: "bg-slate-200 text-slate-600 border-slate-300",
};

export const STATUS_HEX = {
  Pending: "#f59e0b",
  Optimising: "#0ea5e9",
  "At Machine": "#06b6d4",
  "In Rework Rack": "#6366f1",
  "Completed - Finished Rack": "#22c55e",
  "Completed - Maintenance": "#84cc16",
  "In Maintenance Clearing": "#f59e0b",
  "Left Factory": "#64748b",
  "Collected": "#14b8a6",
  "On Hold": "#f97316",
  Cancelled: "#94a3b8",
};

export const SHORT_STATUS = {
  "Completed - Finished Rack": "Done · Finished Rack",
  "Completed - Maintenance": "Done · Maintenance",
  "In Maintenance Clearing": "Maintenance Clearing",
  "Left Factory": "Left Factory",
  "Collected": "Collected",
};

export const PRIORITY_STYLES = {
  Urgent: "bg-red-100 text-red-800 border-red-300",
  Normal: "bg-[#efece5] text-[#424e43] border-[#cfcfc9]",
  Low: "bg-slate-100 text-slate-600 border-slate-300",
};

export const TYPE_STYLES = {
  Rework: "bg-[#647265]/15 text-[#424e43] border-[#647265]/40",
  Missing: "bg-rose-100 text-rose-800 border-rose-300",
};

export const isClosed = (s) => COMPLETED.includes(s) || s === "Cancelled" || s === MAINTENANCE;

export function nextStatus(s) {
  if (s === "On Hold") return "At Machine";
  const i = STAGE_FLOW.indexOf(s);
  if (i === -1) return null;
  if (i === STAGE_FLOW.length - 1) return "Complete";
  return STAGE_FLOW[i + 1];
}

export function heldFromStatus(rework) {
  if (rework.status !== "On Hold") return null;

  const history = rework.status_history || [];

  for (let index = history.length - 2; index >= 0; index -= 1) {
    const previousStatus = history[index]?.status;

    if (previousStatus && previousStatus !== "On Hold") {
      return previousStatus;
    }
  }

  return null;
}

export function daysSince(iso) {
  if (!iso) return 0;
  return Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
}

// Ageing rules from the process review: Pending > 1 day is stale; work stages > 7 days is overdue.
export function ageFlag(r) {
  if (isClosed(r.status)) return null;
  const stageDays = daysSince(r.status_changed_at || r.date_submitted);
  if (r.status === "Pending" && stageDays >= 1) return { level: "stale", label: `Waiting ${stageDays}d`, days: stageDays };
  if (["Optimising", "At Machine", "In Rework Rack"].includes(r.status) && stageDays >= 7) return { level: "overdue", label: `${stageDays}d in stage`, days: stageDays };
  if (r.required_by && new Date(r.required_by) < new Date()) return { level: "overdue", label: "Past required date", days: stageDays };
  return null;
}

const NZ = { timeZone: "Pacific/Auckland" };
export const fmtDate = (v) => v ? new Date(v).toLocaleDateString("en-NZ", { ...NZ, day: "2-digit", month: "short", year: "numeric" }) : "—";
export const fmtDateTime = (v) => v ? new Date(v).toLocaleString("en-NZ", { ...NZ, day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false }) : "—";
export const fmtTime = (v) => new Date(v || Date.now()).toLocaleTimeString("en-NZ", { ...NZ, hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false });
